"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStringValue = void 0;
const isStringType_1 = require("./isStringType");
const getStringValue = (value) => {
    if (!isStringType_1.isStringType(value)) {
        return undefined;
    }
    return value;
};
exports.getStringValue = getStringValue;
//# sourceMappingURL=getStringValue.js.map